import React from "react";
import PlexSpinner from "./workspace/PlexSpinner";

/**
 * PLEX-6361: shown next to a conversation's title in a history list while an agent is still
 * working on it (Tim on PLEX-6087: "annotate active agents (dedicated icon next to title)").
 * Which ones are running comes from llm/runningConversations.
 */
const ActiveAgentIcon = ({ size = 14 }) => (
  <span
    className="active-agent-icon"
    title="An agent is still working on this conversation"
    data-testid="active-agent-icon"
  >
    <PlexSpinner size={size} role="img" ariaLabel="Agent working" />
  </span>
);

export default ActiveAgentIcon;
